import { render, staticRenderFns } from "./MCart.vue?vue&type=template&id=64c23aea&scoped=true"
import script from "./MCart.vue?vue&type=script&lang=js"
export * from "./MCart.vue?vue&type=script&lang=js"
import style0 from "./MCart.vue?vue&type=style&index=0&id=64c23aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c23aea",
  null
  
)

export default component.exports